@if (endNodeForm) {
  <div class="form-container">
    <clickatell-expansion-panel>
      <ng-container header>
        <mat-panel-title>
          Parameters
        </mat-panel-title>
      </ng-container>
      <ng-container body>
        <ng-container [formGroup]="endNodeForm">
          <div class="control-div">
            <div class="control-label-container">
              <label class="control-label"> Name </label>
            </div>
            <ng-container *ngTemplateOutlet="validators; context: { myControlName: 'name', myForm: endNodeForm}"></ng-container>
            <input class="control-input" activeForm [activeForm]="endNodeForm" id="name" [formControlName]="'name'" placeholder="Enter name"/>
          </div>
          <div class="control-div">
            <div class="control-label-container">
              <label class="control-label"> Description </label>
            </div>
            <ng-container *ngTemplateOutlet="validators; context: { myControlName: 'description', myForm: endNodeForm}"></ng-container>
            <input class="control-input" activeForm [activeForm]="endNodeForm" id="description" [formControlName]="'description'" placeholder="Enter description"/>
          </div>
        </ng-container>
      </ng-container>
    </clickatell-expansion-panel>
  </div>
}

<ng-template #validators let-myControlName="myControlName" let-myForm=myForm>
  @if (myForm.controls[myControlName]; as control) {
    @if (control.invalid && (control.dirty || control.touched)) {
      <div class="validationField">
        @for (error of control.errors | keyvalue; track error) {
          <div>
            <span class="fa fa-exclamation-circle"></span>
            <span [id]="'validationField-' + myControlName">
              {{error.value}}
            </span>
          </div>
        }
      </div>
    }
  }
</ng-template>
